/**
 * Created by Alex Aguilar on 5/24/2016.
 */
(function(){
    'use strict';

    angular.module('completeAir.datetimePicker', [])
        .directive('accTimePicker', accTimePicker)
        .directive('accValidateTime', accValidateTime)
        .directive('accTimePickerCopy', ['$rootScope', accTimePickerCopy]);

    function accTimePickerCopy($rootScope){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs){
            var vm = scope.vm;
            element.on('change', function(){
                var indexX = parseInt(attrs.indexX),
                    indexY = parseInt(attrs.indexY),
                    indexSize = parseInt(attrs.indexSize),
                    segmentName = attrs.segment,
                    nameKey = segmentName.replace(/[-() ]/g, "_");

                scope.$apply(function() {
                    var newTimeKey = "0:00";
                    if(vm.flightTimes[nameKey] != undefined){
                        newTimeKey = vm.flightTimes[nameKey].time;
                    }

                    var newTime = sumTime(element.val(), newTimeKey);

                    vm.itineraryFlight.departures[indexX].stretchRoutes[indexY].arrivalTime = newTime;
                    for(var i = indexY + 1; i < indexSize; i++){
                        var eleDepartureTime = $("#departureTime_" + indexX + "_" + i),
                            eleSegment = eleDepartureTime.attr('data-segment'),
                            eleKey = eleSegment.replace(/[-() ]/g, "_"),
                            timeKey = "0:00";

                        if(vm.flightTimes[eleKey] != undefined){
                            timeKey = vm.flightTimes[eleKey].time;
                        }

                        var newTimeCurrent = vm.itineraryFlight.departures[indexX].stretchRoutes[i-1].arrivalTime,
                            eleTime = sumTime(newTimeCurrent, timeKey);

                        vm.itineraryFlight.departures[indexX].stretchRoutes[i].departureTime = newTimeCurrent;
                        vm.itineraryFlight.departures[indexX].stretchRoutes[i].arrivalTime = eleTime;
                    }
                    //vm.change();
                });
            });


        }
    }

    function accTimePicker() {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            element.timepicker({
                minuteStep: 15,
                showSeconds: false,
                showMeridian: false,
                defaultTime: ''
            }).on('show.timepicker', function(e) {
                element.timepicker('setTime', ngModel.$modelValue);
            });
        }
    }

    function accValidateTime(){
        var directive = {
            restrict: 'AC',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            element.on('change', function(){
                var targetTime = $('#' + attrs.targetTime),
                    targetTimeValue = targetTime.val(),
                    timeValue = $(this).val(),
                    typeValidate = attrs.typeValidate;

                if (!ngModel || !timeValue){
                    ngModel.$setValidity(typeValidate, true);
                    return;
                }

                var res = compareTime(targetTimeValue, timeValue);

                if(res){
                    ngModel.$setValidity(typeValidate, false);
                }else {
                    ngModel.$setValidity(typeValidate, true);
                }
            });

        }

        function compareTime(timeOne, timeTwo){
            var timeOneSplit = timeOne.split(':'),
                timeTwoSplit = timeTwo.split(':'),
                dateOne = new Date(),
                dateTwo = new Date();

            dateOne.setHours(timeOneSplit[0]);
            dateOne.setMinutes(timeOneSplit[1]);
            dateOne.setSeconds(timeOneSplit[2]);
            dateTwo.setHours(timeTwoSplit[0]);
            dateTwo.setMinutes(timeTwoSplit[1]);
            dateTwo.setSeconds(timeTwoSplit[2]);

            var res = false;

            if(dateOne.valueOf() === dateTwo.valueOf()){
                res = true;
            }else if(dateTwo.valueOf() < dateOne.valueOf()){
                res = true;
            }
            return res;
        }
    }

    function sumTime(timeCurrent, timeAux){
        if(timeCurrent.indexOf(":") > -1){
            var timeCurrentSplit = timeCurrent.split(":"),
            timeAuxSplit = timeAux.split(":");

            var sumMinutes = parseInt(timeCurrentSplit[1]) + parseInt(timeAuxSplit[1]),
                sumHour = parseInt(timeCurrentSplit[0]) + parseInt(timeAuxSplit[0]);

            if(sumMinutes >= 60){
                sumHour = sumHour + 1;
                sumMinutes = sumMinutes - 60;
            }

            if(sumHour >= 24){
                sumHour = sumHour - 24;
            }

            if(sumHour < 10){
                sumHour = "0" + sumHour;
            }

            if(sumMinutes < 10){
                sumMinutes = "0" + sumMinutes;
            }
        }
        return sumHour + ":" + sumMinutes;
    }

})();
